module.exports = __webpack_public_path__ + "img/quiz-music.ebf836a3.png";